import { assetsClipRetrieve, ClipAssetResponse, MediaContentResponse } from '@goldcast/api/content';
import { DEFAULT_AUDIO_CONTENT_MAGIC_LAYOUT, DEFAULT_MAGIC_LAYOUT } from '../constants/clip-defaults';
import { Clip } from '../types/clip-types';
import { isClipFromUploads } from '../utils/clipUtils';
import { isAudioContent } from '../utils/mediaContentUtils';

export function loadClip(id: string, extraQueryParams = ''): Promise<any> {
  let queryParams = '?speakers=true';

  if (extraQueryParams) {
    queryParams += extraQueryParams;
  }

  queryParams += '&block_speaker_layouts=false';

  return assetsClipRetrieve({ id: id + queryParams }).then((clip: ClipAssetResponse) => {
    const isAudio = isAudioContent(clip.content as MediaContentResponse);
    return {
      ...clip,
      id: clip.id,
      isLoading: false,
      event: clip.content!.project.id,
      broadcast: clip.content!.id,
      organization: clip.asset_metadata.organization,
      title: clip.title,
      broadcast_data: {
        title: clip.content!.title
      },
      content: clip.content,
      asset_metadata: {
        ...(isClipFromUploads(clip as Clip) && {
          magicLayout: isAudio ? DEFAULT_AUDIO_CONTENT_MAGIC_LAYOUT : DEFAULT_MAGIC_LAYOUT
        }),
        ...clip.asset_metadata
      },
      rating: clip.rating,
      isRemoved: false,
      layout_status: clip.layout_status,
      shared: clip.shared,
      locked: clip?.locked,
      updated_at: clip.updated_at,
      first_frame_analysis: clip.first_frame_analysis,
      saved_search: clip.saved_search
    };
  });
}
